// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__h1Lne","productName":"Table_productName__3p1Sr"};